import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/inquiries").then((r) => setItems(r.data)).catch(()=>{}); }, []);
  return (
    <DashboardLayout title="Bulk sourcing inquiries">
      <Card>
        <CardHeader><CardTitle className="font-heading tracking-tight">{items.length} inquir{items.length===1?"y":"ies"}</CardTitle></CardHeader>
        <CardContent>
          {items.length === 0 ? (
            <div className="py-10 text-center text-muted-foreground text-sm" data-testid="admin-inquiries-empty">No inquiries.</div>
          ) : (
            <div className="divide-y divide-border" data-testid="admin-inquiries-list">
              {items.map((i) => (
                <div key={i.id} className="py-4" data-testid={`admin-inq-${i.id}`}>
                  <div className="flex items-center justify-between">
                    <div>
                      <div className="font-medium text-secondary">{i.category}</div>
                      <div className="text-xs text-muted-foreground mt-0.5">{i.buyer?.company_name || i.buyer?.name} ({i.buyer?.email})</div>
                    </div>
                    <StatusBadge status={i.status} />
                  </div>
                  <div className="text-xs text-muted-foreground mt-2">Volume: {i.target_volume} · Dest: {i.destination_country} · Budget: {i.budget || "—"}</div>
                  {i.notes && <p className="mt-2 text-sm text-muted-foreground whitespace-pre-wrap">{i.notes}</p>}
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
